module.exports = __webpack_public_path__ + "media/video604.4fc7fd03.mp4";